import Cookies from "js-cookie";

export const userRole = () => {
   const cookieValue =
      Cookies.get("loginToken") && JSON.parse(Cookies.get("loginToken"));
   const role = cookieValue?.userDetails?.userType;
   return role;
};
